import { SiteApi } from '@linktivity/ars-neo';
import config from './config';

const siteApi = new SiteApi(config);

export default siteApi;
